import { useTranslation } from 'react-i18next';

import { OnboardingStyle } from '../../public/onboarding/onboarding-style';
import { AuthHeader, ContentLayout } from '../../../global-styles/layout';
import { Heading2Text } from '../../../components/typography/typography';
import { images } from '../../../assets/images/images';
import { FinishStyles } from './finish.style';

const Finish = () => {
  const { t } = useTranslation(['common', 'completed']);

  return (
    <ContentLayout>
      <FinishStyles>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                <Heading2Text as="h1" weight={600}>
                  {t('completed:title')}
                </Heading2Text>
              </div>
              <div className="auth-header-title">
                <Heading2Text as="h2" weight={600}>
                  {t('completed:text')}
                </Heading2Text>
              </div>
            </AuthHeader>
            <div className="completed-img">
              <img src={images.cars} alt="" />
            </div>
          </div>
        </OnboardingStyle>
      </FinishStyles>
    </ContentLayout>
  );
};

export default Finish;
